
import { BrowserModule } from '@angular/platform-browser';
import {NgModule } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppComponent } from './app.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from './auth/auth.module';
import { MainModule } from './main/main.module';
import { NetworkService } from './shared/network.service';
import { CommonService } from './shared/common.service';
import { AuthGuardMain } from './auth/auth-guard.service';
import { AppRoutingModule } from './app.routing';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { InitialServiceService } from './initial-service.service';
import { DeletemodalComponent } from './shared/deletemodal/deletemodal.component';
import { SharedModule } from './shared/shared.module';
import { ChatService } from './main/circles/chat.service';

const routes: Routes = [
];


@NgModule({
  declarations: [
    AppComponent,
    DeletemodalComponent,
  ],
  imports: [
    AuthModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule,
    MainModule,
    NgbModule,
    AppRoutingModule,
    RouterModule.forRoot(routes),
    SharedModule,

  ],
  providers: [NetworkService,CommonService,AuthGuardMain, InitialServiceService, ChatService],
  bootstrap: [AppComponent],
  entryComponents:[DeletemodalComponent]
})
export class AppModule {}
